import { useCallback } from 'react'

import type { SigninUpstream } from '../experiments'

export function useEnsureAuthServerCsrf(flow: 'stable' | 'rollout' = 'stable') {
  const ensureAuthServerCsrf = useCallback(async (): Promise<void> => {
    try {
      const response = await fetch(`/api/auth-bootstrap-csrf?flow=${flow}`)
      if (!response.ok) return
      const data: { csrfToken?: string | null; upstream?: SigninUpstream } = await response.json()

      if (flow === 'rollout' && data.upstream) {
        writeMeta('signin-upstream', data.upstream)
      }
      if (data?.csrfToken) {
        writeMeta('auth-csrf-token', data.csrfToken)
      }
    } catch {
      // fail-open: never block on CSRF bootstrap failure
    }
  }, [flow])

  return { ensureAuthServerCsrf }
}

function writeMeta(name: string, content: string) {
  let meta = document.querySelector(`meta[name="${name}"]`) as HTMLMetaElement | null
  if (!meta) {
    meta = document.createElement('meta')
    meta.name = name
    document.head.appendChild(meta)
  }
  meta.content = content
}
